import React from 'react';
import MicroApp from '@/components/micro-app';
import useHideBreadCrumbs from '@/components/bread-crumbs/use-hide-bread-crumbs.ts';
import env from '@/env';
import { getQuery } from '@/common/utils';
import { usePerformanceApis, getTemplateSchema } from '@/apiperformance';

const performanceApis = [getTemplateSchema];
function GoldProcessExchangeMicroAppApplication() {
  const pageId = getQuery('pageId');
  const url = `${env.MC_DOMAIN}/pages/pageDetail/?pageId=${pageId}`;

  // @ts-ignore
  const prefetchApis = usePerformanceApis(performanceApis);

  useHideBreadCrumbs();
  return <MicroApp name="gold-process-exchange" url={url} data={{ ...prefetchApis }} />;
}

export default GoldProcessExchangeMicroAppApplication;
